import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import { StaffViewResource, Permission, PermissionAction } from "generated/openApi";
import "moment-timezone";
import { isAuthorized } from "services";
import { StaffTab } from "./StaffPage";

export const StaffTabs = (props: { viewResource: StaffViewResource; setCurrentTab: (value: StaffTab) => void }) => {
  const tabs: StaffTab[] = initTabs();

  function initTabs(): StaffTab[] {
    let tabs: StaffTab[] = [];
    tabs.push("Profile");
    if (isAuthorized(Permission.StaffService, PermissionAction.View)) tabs.push("Services");
    return tabs;
  }

  const tabTotals: [StaffTab, number | undefined][] = [["Services", props.viewResource.servicesTotal]];

  return (
    <TabList
      onChange={(e, value) => props.setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => {
        const total: number | undefined = tabTotals.find((x) => x[0] === tab)?.[1];

        return (
          <Tab
            key={tab}
            label={
              <Stack direction="row" spacing="sm" alignItems="center">
                <Box>{tab}</Box>
                {total !== undefined && total !== null && <Chip label={total} size="small" />}
              </Stack>
            }
            value={tab}
          />
        );
      })}
    </TabList>
  );
};
